const DOMAINS = {
  'enhance-org_42/web_42': [
    { id: 11, domain: 'customer.de', website_id: 'web_42', type: 'primary', dkim: 'default', dns_status: 'resolved' },
    { id: 12, domain: 'www.customer.de', website_id: 'web_42', type: 'alias', dkim: null, dns_status: 'resolved' },
    { id: 13, domain: '42abc.staging.valitype.net', website_id: 'web_42', type: 'primary', dkim: 'default', dns_status: 'resolved' },
  ],
  'enhance-org_88': [
    { id: 21, domain: 'baeckerei-mueller.de', website_id: 'web_88', type: 'primary', dkim: 'default', dns_status: 'resolved' },
  ],
};

const MAILBOXES = {
  'enhance-org_42/web_42': [
    { address: 'info@customer.de', quota_mb: 500, is_catch_all: false },
    { address: 'support@customer.de', quota_mb: 1000, is_catch_all: false },
  ],
  'enhance-org_88': [
    { address: 'mueller@baeckerei-mueller.de', quota_mb: 500, is_catch_all: false },
  ],
};

const SAMPLE_CUSTOMERS = [
  { id: 7, display_name: 'Agency XYZ', external_id: 'sub_12345' },
  { id: 8, display_name: 'Bäckerei Müller', external_id: null },
];

const SAMPLE_SERVICES_BY_CUSTOMER = {
  7: [
    { id: 1, plugin_id: 'hosting-enhance', kind: 'hosting', account_id: 'enhance-org_42/web_42', subscription_id: 'sub_12345', status: 'active' },
  ],
  8: [
    { id: 3, plugin_id: 'hosting-enhance', kind: 'hosting', account_id: 'enhance-org_88', subscription_id: null, status: 'active' },
  ],
};

export function hostingDomainsFixture(accountId) {
  return { domains: DOMAINS[accountId] ?? [] };
}
hostingDomainsFixture.__sampleCustomers = (search = '') => {
  const needle = search.toLowerCase();
  return SAMPLE_CUSTOMERS.filter(
    (c) =>
      !needle ||
      c.display_name.toLowerCase().includes(needle) ||
      (c.external_id ?? '').toLowerCase().includes(needle),
  );
};
hostingDomainsFixture.__sampleServices = (customerId) => ({
  services: SAMPLE_SERVICES_BY_CUSTOMER[customerId] ?? [],
});

export function hostingMailboxesFixture(accountId) {
  return { mailboxes: MAILBOXES[accountId] ?? [] };
}

export function promoteFixture(domain) {
  return { ok: true, domain, job_id: `promote-${Date.now()}` };
}
